import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { registerSW } from "virtual:pwa-register";
import { App } from "./App";
import { preloadWorldBackground } from "./lib/learningImages";
import "./styles/tokens.css";
import "./styles/global.css";
import "./styles/home.css";
import "./styles/explore.css";
import "./styles/explore-experience.css";
import "./styles/auth.css";
import "./styles/profile.css";
import "./styles/surprise.css";
import "./styles/world.css";
import "./styles/room.css";
import "./styles/learning.css";
import "./styles/mainline-classic.css";
import "./styles/mission-three.css";
import "./styles/star-reward.css";
import "./styles/parent-observation.css";
import "./styles/theme.css";
import "./styles/image-loading.css";
import "./styles/book-library.css";

if (window.location.pathname === '/world') preloadWorldBackground();
const preloadWorldOnIntent = (event: Event) => {
  const link = event.target instanceof Element ? event.target.closest('a') : null;
  if (link && new URL(link.href, window.location.href).pathname === '/world') preloadWorldBackground();
};
document.addEventListener('pointerover', preloadWorldOnIntent, { passive: true });
document.addEventListener('focusin', preloadWorldOnIntent);

if (import.meta.env.PROD) {
  let refreshing = false;
  navigator.serviceWorker?.addEventListener("controllerchange", () => {
    if (refreshing) return;
    refreshing = true;
    window.location.reload();
  });
  let updateServiceWorker: ((reloadPage?: boolean) => Promise<void>) | undefined;
  updateServiceWorker = registerSW({
    immediate: true,
    // Explicit opt-in: do not reload a child's activity without permission.
    onNeedRefresh: () => {
      if (document.getElementById('lusky-update-notice')) return;
      const notice = document.createElement('aside');
      notice.id = 'lusky-update-notice';
      notice.setAttribute('role', 'status');
      notice.style.cssText = 'position:fixed;bottom:20px;left:50%;transform:translateX(-50%);z-index:10000;max-width:90vw;padding:16px;border-radius:16px;background:#fff;color:#14205b;box-shadow:0 4px 24px #0004;display:flex;gap:12px;align-items:center';
      const message = document.createElement('span');
      message.textContent = '新版本已准备好，更新将重新打开页面。';
      const button = document.createElement('button');
      button.textContent = '立即更新';
      button.onclick = () => { button.disabled = true; void updateServiceWorker?.(true).catch(() => { button.disabled = false; message.textContent = '更新失败，请检查网络后重试。'; }); };
      notice.append(message, button);
      document.body.append(notice);
    },
    onRegisteredSW: (_scriptUrl, registration) => { void registration?.update(); }
  });
} else if ("serviceWorker" in navigator) {
  void navigator.serviceWorker.getRegistrations().then((registrations) =>
    Promise.all(registrations.map((registration) => registration.unregister()))
  );
}
createRoot(document.getElementById("root")!).render(<StrictMode><App /></StrictMode>);
